import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CandidateJobStatus } from '@shared/models';

import { ApiService } from './api.service';
import { ReferralReportsFilters } from '@modules/reports/models/referral-reports-filters';
import { DashboardReportModel } from '@shared/models/dashboard-reports';

@Injectable({ providedIn: 'root' })
export class HiringManagerService extends ApiService<CandidateJobStatus> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'hiring-manager/';
  }

  getStatuses(jobId, candidateIds): Observable<CandidateJobStatus[]> {
    return this.post({ url: 'statuses', body: { jobId, candidateIds } });
  }

  getAvgResponseTimeForJobId(jobIds: number[]) {
    const ids = jobIds.join(',');
    return this.get({
      url: `average-response-time?jobIds=${ids}`,
    });
  }

  getDashboardReportServiceSubmission(
    params: ReferralReportsFilters,
  ): Observable<DashboardReportModel> {
    return this.get({ url: 'reports/dashboard/candidate-submission', params });
  }
}
